import { StudentOverview } from "layout/StudentOverview";
import type React from "react";

export const Preview: React.FC = () => <StudentOverview />;
